export default __webpack_public_path__ + "static/media/touchOne.898425ef.svg";